import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import { Building2, CreditCard, Hash, User } from 'lucide-react'

import { CopiableContactField } from '@/components/research-bar/copiable-contact-field'
import { BANK_ACCOUNT_HOLDER, BANK_BIC, BANK_IBAN, BANK_NAME } from '@/lib/constants/agency'

interface BankTransferDetailsProps {
  installmentPaymentDeadline?: string
}

export function BankTransferDetails({ installmentPaymentDeadline }: BankTransferDetailsProps) {
  const deadlineFormatted = installmentPaymentDeadline
    ? format(installmentPaymentDeadline, 'dd MMMM yyyy', { locale: fr })
    : null

  return (
    <div className="flex w-full flex-col gap-4 px-4 pb-4">
      {deadlineFormatted && (
        <div className="flex items-center justify-between">
          <div className="text-gray-light-700 text-sm font-medium">
            Date limite de réception du virement
          </div>
          <div className="text-gray-light-900 text-sm font-semibold">{deadlineFormatted}</div>
        </div>
      )}
      <div className="flex flex-col gap-4">
        <div className="flex gap-3">
          <CopiableContactField icon={User} label="Nom" value={BANK_ACCOUNT_HOLDER} />
          <CopiableContactField icon={CreditCard} label="IBAN" value={BANK_IBAN} />
        </div>
        <div className="flex gap-3">
          <CopiableContactField icon={Building2} label="Banque" value={BANK_NAME} />
          <CopiableContactField icon={Hash} label="Code Banque" value={BANK_BIC} />
        </div>
      </div>
    </div>
  )
}
